export default __webpack_public_path__ + "static/sticky-logo-text-1312ae75d960a1fc9da822ee44426a61.svg";